import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsCollectorsHelpRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-collectors-help',
	path: '/secure/InsertCollectorHelp([!%]?[\\w]*).jspa',
	query: ['projectKey'],
};
